import { PbaComparabilitySearch } from './pba-comparability-search';
import { ComparabilitySearchFinalRange } from './comparability-search-final-range';

export class MethodEvaluationComparabilitySearch extends PbaComparabilitySearch {
  srcDiscussionCollapsed?: boolean;
  destDiscussionCollapsed?: boolean;
  testedPartyCollapsed?: boolean;
  finalRangeResults?: ComparabilitySearchFinalRange[];
}
